import { c as _c } from "react/compiler-runtime";
import { SanityImageSource } from '@sanity/image-url';
import Image from 'next/image';
import Link from 'next/link';
import { urlFor } from '@/sanity/lib/image';
import type { SITE_SETTINGS_QUERY_RESULT } from '@/sanity/types';
import MastHeadMobileProvider from './MastHeadMobileProvider';

// Extract mastheadNavigation type from query result
type MastheadNavigationType = NonNullable<SITE_SETTINGS_QUERY_RESULT>['mastheadNavigation'];
export default function MastHeadMobile(t0) {
  const $ = _c(17);
  const {
    mastheadNavigation,
    logo,
    careers,
    variant
  } = t0;
  if (!mastheadNavigation) {
    return null;
  }
  const {
    navigation
  } = mastheadNavigation;
  let t1;
  if ($[0] !== careers || $[1] !== mastheadNavigation || $[2] !== navigation || $[3] !== variant) {
    t1 = <div className="justify-self-start"><MastHeadMobileProvider navigation={navigation} mastheadNavigation={mastheadNavigation} careers={careers} variant={variant} /></div>;
    $[0] = careers;
    $[1] = mastheadNavigation;
    $[2] = navigation;
    $[3] = variant;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = careers ? "/careers" : "/";
  let t3;
  if ($[5] !== logo) {
    t3 = urlFor(logo).width(600).height(600).url();
    $[5] = logo;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = logo?.altText || "logo";
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <Image className="w-22" src={t3} width={600} height={600} alt={t4} />;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t5) {
    t6 = <Link aria-label="Home" href={t2} className="justify-self-center">{t5}</Link>;
    $[10] = t2;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div />;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t1 || $[15] !== t6) {
    t8 = <div className="grid h-full max-w-7xl grid-cols-[1fr_auto_1fr] items-center px-5 justify-center">{t1}{t6}{t7}</div>;
    $[14] = t1;
    $[15] = t6;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}